import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from 'environments/environment';

export interface ViaCepResponse {
    cep: string;
    logradouro: string;
    complemento: string;
    bairro: string;
    localidade: string;
    uf: string;
    ibge: string;
    gia: string;
    ddd: string;
    siafi: string;
    erro?: boolean;
}

export interface ICepResponse {
    cep: string;
    state: string;
    city: string;
    street: string;
    neighborhood: string;
}

@Injectable({
    providedIn: 'root'
})
export class ViaCepService {
    private readonly baseUrl = environment.apiUrl + '/api';

    constructor(private http: HttpClient) {}

    /**
     * Search address data by zip code via backend
     * @param zipCode Zip code for search (numbers only)
     * @returns Observable with address data or null if error
     */
    searchZipCode(zipCode: string): Observable<ICepResponse | null> {
        const cleanZipCode = zipCode.replace(/\D/g, '');
        
        if (cleanZipCode.length !== 8) {
            return of(null);
        }

        const url = `${this.baseUrl}/cep/${cleanZipCode}`;
        
        return this.http.get<ICepResponse>(url).pipe(
            catchError(() => of(null))
        );
    }

    /**
     * Format zip code for display (00000-000)
     * @param zipCode Zip code with or without formatting
     * @returns Formatted zip code
     */
    formatZipCode(zipCode: string): string {
        const cleanZipCode = zipCode.replace(/\D/g, '');
        if (cleanZipCode.length === 8) {
            return cleanZipCode.replace(/(\d{5})(\d{3})/, '$1-$2');
        }
        return zipCode;
    }

    /**
     * Validate if zip code is in correct format
     * @param zipCode Zip code for validation
     * @returns true if valid, false otherwise
     */
    validateZipCode(zipCode: string): boolean {
        const cleanZipCode = zipCode.replace(/\D/g, '');
        return cleanZipCode.length === 8;
    }
}
